<template>
    <text-field :config="config" :key="config.storeField"></text-field>
</template>
<script>
    import TextField from '../template/TextField';

    export default {
        components: {TextField},
        data: function () {
            return {
                config: {
                    question: 'What is your full name?',
                    fields: [
                        {
                            display: 'First Name',
                            name: 'first',
                            rules: [
                                v => !!v || 'Required',
                                v => !v || v.length >= 2 || 'Name must be at least 2 characters',
                                v => !v || v.length <= 50 || 'Maximum of 50 characters is allowed',
                                v => !v || /[aeiouAEIOUyY]/.test(v) || 'Please enter a valid name',
                                v => !v || !(/^(.)\1+$/.test(v.replace(/\s/g, ''))) || 'Please enter a valid name',
                                v => !v || /^[a-zA-Z\s'-]+$/.test(v) || 'Name can only contain letters, spaces, hyphens, and apostrophes'
                            ]
                        },
                        {
                            display: 'Last Name',
                            name: 'last',
                            rules: [
                                v => !!v || 'Required',
                                v => !v || v.length >= 2 || 'Name must be at least 2 characters',
                                v => !v || v.length <= 50 || 'Maximum of 50 characters is allowed',
                                v => !v || /[aeiouAEIOUyY]/.test(v) || 'Please enter a valid name',
                                v => !v || !(/^(.)\1+$/.test(v.replace(/\s/g, ''))) || 'Please enter a valid name',
                                v => !v || /^[a-zA-Z\s'-]+$/.test(v) || 'Name can only contain letters, spaces, hyphens, and apostrophes'
                            ]
                        }
                    ],
                    storeField: 'name',
                    clickBack: function () {
                        this.$router.go(-1)
                    }.bind(this),
                    clickContinue: async function () {
                        await this.$router.push('/reg/phone')
                    }.bind(this)
                }
            }
        }
    }
</script>
